import { useMemo } from "react";
import { useBranchLimits } from "../../BranchLimits";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { ResourceView } from "../../../dto/ResourceView";

// TODO update to accept includeTextualHoldings and viewSelectedHoldings
export function useVisibleHoldings(
  resource: ResourceDWR | ResourceView,
  reservesOnly?: boolean
) {
  const { displayInCopiesBranchIds, selectedBranchIds } = useBranchLimits();

  const filteredHoldings = useMemo(() => {
    if (!resource || !Array.isArray(resource.holdingsInformations)) {
      return [];
    }

    const holdings = resource.holdingsInformations.filter(
      (hi) => hi.reserved || !reservesOnly
    );

    if (selectedBranchIds?.length) {
      return holdings.filter((holding) =>
        selectedBranchIds.includes(holding.branchIdentifier)
      );
    }

    return holdings.filter((holding) =>
      displayInCopiesBranchIds.includes(holding.branchIdentifier)
    );
  }, [resource, displayInCopiesBranchIds, selectedBranchIds]);

  return filteredHoldings;
}
